function fillDropdown (url) {
    const sector = url.searchParams.get('referenceSector');
    const product = url.searchParams.get('referenceProduct');

    if (sector) {
        const $sectorInput = $(`#${sector}`);
        $sectorInput.prop('checked', true);
        $sectorInput.trigger('change');
    }

    if (product) {
        const $productInput = $(`#${product}`);
        $productInput.prop('checked', true);
        $productInput.trigger('change');
    }
}

export default fillDropdown;



// WEBPACK FOOTER //
// ./src/scripts/components/references/fillDropdown.js